import script from "./Module.vue?vue&type=script&setup=true&lang=js"
export * from "./Module.vue?vue&type=script&setup=true&lang=js"

import "./Module.vue?vue&type=style&index=0&id=1215f3ac&lang=scss"

const __exports__ = script;

export default __exports__